/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import QueuesDetailsPanel from './layout';

import { getSelectedEntityId } from '../../../redux/modules/entities/selectors';
import {
  isAllQueuesFormDependenciesFetched,
  getSelectedQueueVersions,
  getSelectedQueueActiveVersion,
} from '../../../redux/modules/entities/queues/selectors';

export const mapStateToProps = (state) => ({
  selectedEntityId: getSelectedEntityId(state),
  selectedQueueVersions: getSelectedQueueVersions(state),
  activeQueueVersion: getSelectedQueueActiveVersion(state),
  isAllDependentEntitiesFetched: isAllQueuesFormDependenciesFetched(state),
});

export default connect(mapStateToProps)(QueuesDetailsPanel);
